import { render, staticRenderFns } from "./DefaultDone.vue?vue&type=template&id=50470554"
import script from "./DefaultDone.vue?vue&type=script&lang=ts"
export * from "./DefaultDone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports